import { render, staticRenderFns } from "./NewsTabCallToActions.vue?vue&type=template&id=57875ffc&"
import script from "./NewsTabCallToActions.vue?vue&type=script&lang=js&"
export * from "./NewsTabCallToActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports